export default "__VITE_ASSET__DdK_1lA9__"